import type { AboutCompany as AboutCompanyType } from "@repo/fetch-repository/aboutCompany";
import { useApp } from "@repo/app/useApp";
import { observer } from "mobx-react-lite";
import { ArrowButton } from "../../common/arrow-button";

export interface AboutCompanyProps {
  item: AboutCompanyType;
}

export const AboutCompanyItem = observer(
  ({ item }: AboutCompanyProps): React.JSX.Element | null => {
    const app = useApp();
    const isEditor = app.rendererMode === "editor";
    return !Array.isArray(item.file.data) ? (
      <a
        className="w-full h-full flex flex-col items-start justify-start gap-y-4 group"
        href={item.link}
        onClick={(e) => {
          if (isEditor) {
            e.preventDefault();
          }
        }}
      >
        <img
          alt={item.file.data.alt || item.title}
          className="w-full h-[123px] object-contain object-left rtl:object-right"
          onError={(e) => {
            e.currentTarget.src = "/images/placeholder.png";
          }}
          src={item.file.data.url}
        />
        <h3 className="font-helvetica rtl:font-doran text-[23.8px] font-[100] rtl:font-bold leading-normal tracking-[-0.24px] text-left text-[#4c4c4c] transition-colors group-hover:text-[#f70] uppercase pt-3">
          {item.title}
        </h3>
        <p className="font-helvetica rtl:font-doran text-[14px] md:text-[15px] lg:text-[16.5px] font-light rtl:font-medium leading-normal tracking-[-0.16px] text-[#4c4c4c]">
          {item.description}
        </p>
        <div className="w-full flex items-center justify-end gap-x-4 lg:pr-20 lg:rtl:pl-20">
          <ArrowButton />
        </div>
      </a>
    ) : null;
  }
);
